import { observer } from 'mobx-react';
import {
  IntegrationConnectionType,
  PartnerId,
  TRANSLATIONS_AUTH_PARTNERS,
  USER_ORG_ID,
  v3Integrations,
} from 'models/Integration';
import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { RootContext } from '../../RootProvider';
import { RoutePaths } from '../../routes/history';
import FourZeroFourView from './FourZeroFourView';
import LoadingView from './LoadingView';
import { useContext, useEffect, useState } from 'react';
import {
  AmplitudeEventEnum,
  AmplitudePropertyKeyEnum,
  useAmplitude,
} from 'services/amplitudeHelper';

const CallbackView = observer(() => {
  const { integrations } = useContext(RootContext);
  const history = useHistory();
  const { partner_id } = useParams<{ partner_id: string }>();
  const [responseState, setResponseState] = useState('LOADING');
  const trackEvent = useAmplitude();

  useEffect(() => {
    if (!partner_id) return;
    integrations.setActiveIntegration(partner_id);
  }, [partner_id, integrations]);

  useEffect(() => {
    const handleCallback = async () => {
      const response = await integrations.handle_partner_callback(partner_id ?? '');
      if (response?.error_type) {
        setResponseState('FAIL');
        return;
      }

      integrations.setSelectedIntegrationTab(integrations._active_integration?.connection_type);

      if (Object.keys(v3Integrations).includes(partner_id)) {
        if (PartnerId.Trimble2 === partner_id) {
          const search = new URLSearchParams(window.location.search);
          const code: string | null = search.get('code');
          if (code) {
            await integrations.handleTrimbleGetTokenAndRedirectToGrantOrgs(code);
            return;
          }
        }

        trackEvent(AmplitudeEventEnum.CONNECTED_NEW_INTEGRATION, {
          [AmplitudePropertyKeyEnum.INTEGRATION_NAME]:
            integrations.activeIntegration?.integration_name,
        });
        history.push(RoutePaths.ConfigurationViewV3(partner_id).toString());
        return;
      }

      trackEvent(AmplitudeEventEnum.CONNECTED_NEW_INTEGRATION, {
        [AmplitudePropertyKeyEnum.INTEGRATION_NAME]:
          integrations.activeIntegration?.integration_name,
      });

      if (
        integrations._active_integration?.connection_type ===
          IntegrationConnectionType.observation ||
        TRANSLATIONS_AUTH_PARTNERS.includes(partner_id)
      ) {
        window.localStorage.setItem(USER_ORG_ID, integrations.activeUser);

        history.push({
          pathname: RoutePaths.ConfigureIntegrationWizardView(partner_id).toString(),
          search: window.location.search,
        });
      } else {
        history.push(RoutePaths.ImportOrganizationsView(partner_id).toString());
      }
    };

    if (integrations.activeUser && partner_id && integrations.activeIntegration) {
      handleCallback();
    }
  }, [
    history,
    integrations,
    partner_id,
    integrations.activeUser,
    integrations.activeIntegration,
    trackEvent,
  ]);

  const ComponentReturn: Record<string, JSX.Element> = {
    LOADING: <LoadingView />,
    FAIL: <FourZeroFourView />,
  };

  if (ComponentReturn[responseState]) return ComponentReturn[responseState];

  return <h1>Callback</h1>;
});

export default CallbackView;
